import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './App.css';

// Page imports
import HomePage from './pages/HomePage';
import CustomerSupportPage from './pages/CustomerSupportPage';
import BusinessIntelligencePage from './pages/BusinessIntelligencePage';
import WorkflowAutomationPage from './pages/WorkflowAutomationPage';
import DocumentProcessingPage from './pages/DocumentProcessingPage';
import SalesMarketingPage from './pages/SalesMarketingPage';
import ComplianceRiskPage from './pages/ComplianceRiskPage';

const App = () => {
    const location = useLocation();
    
    useEffect(() => {
        const savedTheme = localStorage.getItem('theme') || 'light';
        if (savedTheme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, []);
    
    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<HomePage />} />
                <Route path="/customer-support" element={<CustomerSupportPage />} />
                <Route path="/business-intelligence" element={<BusinessIntelligencePage />} />
                <Route path="/workflow-automation" element={<WorkflowAutomationPage />} />
                <Route path="/document-processing" element={<DocumentProcessingPage />} />
                <Route path="/sales-marketing" element={<SalesMarketingPage />} />
                <Route path="/compliance-risk" element={<ComplianceRiskPage />} />
            </Routes>
        </AnimatePresence>
    );
};

export default App;
